import React, { useCallback, useEffect, useState } from 'react';
import { Network, Users, Building2, Send, BookOpen } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { PartnersTab } from '../components/partnerships/PartnersTab';
import { DirectoryTab } from '../components/partnerships/DirectoryTab';
import { SharedPropertiesTab } from '../components/partnerships/SharedPropertiesTab';
import { ReferralsTab } from '../components/partnerships/ReferralsTab';


const TABS = [
  { value: 'partners', label: 'Partenaires', icon: Users },
  { value: 'properties', label: 'Biens partagés', icon: Building2 },
  { value: 'referrals', label: 'Clients recommandés', icon: Send },
  { value: 'directory', label: 'Annuaire', icon: BookOpen },
];

export default function Partnerships() {
  const { user } = useAuth();
  const isAdmin = ['admin', 'super_admin'].includes(user?.role);
  const isSuper = user?.role === 'super_admin';
  const [partnerships, setPartnerships] = useState([]);
  const [directory, setDirectory] = useState([]);

  const load = useCallback(async () => {
    try {
      const [p, d] = await Promise.all([api.get('/partnerships'), api.get('/partnerships/directory')]);
      setPartnerships(p.data || []);
      setDirectory(d.data || []);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erreur de chargement'); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const active = partnerships.filter((p) => p.status === 'active');
  const ctx = { isAdmin, isSuper, partnerships, active, directory, reload: load };

  return (
    <div className="space-y-6" data-testid="partnerships-page">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-2xl bg-[#2B3A2C] flex items-center justify-center shadow-md">
          <Network className="w-6 h-6 text-[#F5EFE1]" strokeWidth={1.6} />
        </div>
        <div>
          <h1 className="font-display text-3xl font-bold text-[#2B3A2C] tracking-tight">Partenariats inter-agences</h1>
          <p className="text-sm text-gray-500 mt-1">
            {active.length} partenaire(s) actif(s) · partagez vos biens, recommandez des clients et partagez la commission.
          </p>
        </div>
      </div>
      <Tabs defaultValue="partners" className="space-y-5">
        <TabsList className="flex flex-wrap h-auto gap-1.5 p-1.5 bg-white border border-[#B85C38]/15 rounded-xl">
          {TABS.map((t) => (
            <TabsTrigger key={t.value} value={t.value} data-testid={`partnership-tab-${t.value}`}
              className="flex items-center gap-2 rounded-lg data-[state=active]:bg-[#2B3A2C] data-[state=active]:text-white">
              <t.icon className="w-4 h-4" /> {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="partners"><PartnersTab {...ctx} /></TabsContent>
        <TabsContent value="properties"><SharedPropertiesTab {...ctx} /></TabsContent>
        <TabsContent value="referrals"><ReferralsTab {...ctx} /></TabsContent>
        <TabsContent value="directory"><DirectoryTab {...ctx} /></TabsContent>
      </Tabs>
    </div>
  );
}
